

import {CHF} from "kistenkonfigurator/build/util/currency-util";
import Vue, {PropType} from "vue";
import {ProductModelFactory} from "../../model/product/ProductModelFactory";
import {PriceQuantityTuple} from "../../model/rest/data-contracts";

export default Vue.extend({
  name: "ProductPriceTable",
  props: {
    graduatedPrices: {
      type: Array as PropType<Array<PriceQuantityTuple>>,
      default: () => ProductModelFactory.createEmptyGraduatedPrices(),
    },
  },
  computed: {
    currencyPrices(): Array<{ quantity: string, price: string }> {
      if (this.graduatedPrices == null) {
        return [];
      }

      return this.graduatedPrices
          .map((entry: any) => ({
            quantity: entry.quantity,
            price: entry.price == null ? "" : CHF(entry.price).toString(),
          }))
          .filter(entry => entry.price !== "");
    },
  },
});
